import { makeObservable, observable } from "mobx";
import { ModelBase } from "@shoothill/core";
import { MentorModel } from "Views/Mentors/Mentors/MentorModel";

export class PastMentorsModel extends ModelBase<PastMentorsModel> {
    //filtering
    public filterKeyword: string = "";
    public mentors = observable<MentorModel>([]);

    constructor() {
        super();
        makeObservable(this, {
            filterKeyword: observable,
        });
    }
}
